import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const ResponsiveChart = ({ children, height = 350, mobileHeight = 250 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box 
      sx={{ 
        width: '100%', 
        height: isMobile ? mobileHeight : height,
        '& .recharts-wrapper': {
          fontSize: isMobile ? '12px' : '14px'
        },
        '& .recharts-legend-item-text': {
          fontSize: isMobile ? '11px' : '13px'
        },
        '& .recharts-tooltip-wrapper': {
          fontSize: isMobile ? '11px' : '13px'
        }
      }}
    >
      {children}
    </Box>
  );
};

export default ResponsiveChart; 